import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createNotificationValidationSchema = Yup.object().shape({
  message: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
